import { render, staticRenderFns } from "./fellowship_create.vue?vue&type=template&id=6c7515c9&"
import script from "./fellowship_create.vue?vue&type=script&lang=js&"
export * from "./fellowship_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports